import React from "react";
import "./AdminDashboard.css";
import { connect } from "react-redux";
import {
  getSubmittedFormDataSuccess,
  getSubmittedFormDataFail,
  getAllUsersSuccess
} from '../../reduxModules/dashboardReducer/dashboardActions';
import { bindActionCreators } from "redux";
import { getApiCallable, showNotif } from "../../firebaseModules/apiclient";
import { Card, DatePicker, Button, Spin } from "antd";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { exportToCsv } from '../../utils/utils';
import cx from 'classnames';
import {
  PlusCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';

class AdminDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      boolLoading: false,
      page: 'daily_assessment',
      viewStates: {}
    }
  }
  componentDidMount = async () => {
    this.getSubmittedRequestsData();
  }
  setLoading = (bool) => {
    this.setState({ boolLoading: bool });
  }
  getSubmittedRequestsData = async (date) => {
    try {
      this.setLoading(true);
      const getUserSubmittedAnswersForDateCallable = getApiCallable("getUserSubmittedAnswersForDate");
      const getUserSubmittedAnswersForDateRes = await getUserSubmittedAnswersForDateCallable({ filterDate: date });
      this.setLoading(false);
      this.props.getSubmittedFormDataSuccess(getUserSubmittedAnswersForDateRes);
    } catch (error) {
      showNotif(error);
      this.setLoading(false);
      this.props.getSubmittedFormDataFail();
    }
  }
  getJsDate = (firebaseTimestamp) => {
    const dateObj = new firebase.firestore.Timestamp(firebaseTimestamp._seconds, firebaseTimestamp._nanoseconds).toDate();
    return `${dateObj.toDateString()} ${dateObj.toTimeString()}`;
  }
  getTableData = () => {
    const userData = this.props.dashboardReducer.submiitedUserData || {};
    return (userData.user_answers || []).map((data, index) => {
      const questionAnswers = data.answers;
      // const questions = questionAnswers.map(answer => {
      //   const questionObj = userData.questions.find(ques => answer.question_id === ques.question_id);
      //   const answerId = answer.answer_ids[0];
      //   const answerObj = questionObj && questionObj.answers ? questionObj.answers.find(aa => aa.answer_id === answerId) : {};
      //   return {
      //     question: questionObj ? questionObj.value : '',
      //     answer: answerObj ? answerObj.value : ''
      //   };
      // });

      const questions = userData.questions.map(question => {
        const userAnswerObj = questionAnswers.find(answer => question.question_id === answer.question_id);
        const answerId = userAnswerObj ? userAnswerObj.answer_ids[0] : -1;
        const answerObj = userAnswerObj ? question.answers.find(aa => aa.answer_id === answerId) : undefined;
        return {
          question: question.value,
          answer: answerObj ? answerObj.value : ''
        };
      });
      return {
        email: data.emailId,
        status: data.status,
        submitted_date: this.getJsDate(data.submitted_date),
        questions
      };
    });
  }
  getColumns = () => ([
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Submitted Date',
      dataIndex: 'submitted_date',
      key: 'submitted_date',
    },
  ]);

  renderDataTable = () => {
    const dataSource = this.getTableData();
    return (
      <div className="dailyAssessmentAnswersContainer">
        {
          dataSource.map((row, dataindex) => (
            <div className="userRow" key={dataindex}>
              <div className="basicDetailsRow">
                <span className="email">{row.email}</span>
                <span className="date">{new Date(row.submitted_date).toDateString()}</span>
                <span className={cx('status', row.status)}>{row.status}</span>
              </div>
              {/* <div className="answersRow">
                {
                  row.questions.map((question, qindex) => {
                    return (
                      <div className="questionRow" key={qindex}>
                        {
                          question &&
                          <div className="q">{question.question}</div>
                        }
                        {
                          question &&
                          <div className="a">{question.answer}</div>
                        }
                      </div>
                    );
                  })
                }
              </div> */}
            </div>
          ))
        }
      </div>
    );
  }
  handleDateChange = (date, dateString) => {
    this.setState({
      selectedDate: date,
      selectedDateString: dateString
    });
    this.getSubmittedRequestsData(dateString);
  }
  exportDailyAssessmentDataInCSV = () => {
    const columns = this.getColumns();
    const dataSource = this.getTableData();
    const dataArr = [columns.map(column => column.title)];
    const data = this.props.dashboardReducer.submiitedUserData;
    data && (data.questions || []).map(q => {
      dataArr[0].push(q.value);
    });
    dataSource.map(dataRow => {
      const row = [];
      columns.map(column => {
        row.push(dataRow[column.dataIndex]);
        return null;
      });
      dataRow.questions.map(qq => {
        row.push(qq.answer);
      })
      dataArr.push(row);
      return null;
    });
    let date = new Date();
    if (this.state.selectedDate) {
      date = new Date(this.state.selectedDate);
    }
    const fileName = date.toDateString().split(' ').join('_');
    exportToCsv(`daily_assessment_report_${fileName}.csv`, dataArr);
  }
  exportUsersData = () => {
    const profileQuestions = this.props.dashboardReducer.profileQuestions;
    const rows = [];
    const headerRow = ['Name', 'Email', 'Profile Allowed'];
    profileQuestions.map((q) => {
      headerRow.push(q.text);
    });
    headerRow.push('Created At');
    headerRow.push('Updated At');
    rows.push(headerRow);
    this.props.dashboardReducer.users.map((u) => {
      const userRow = [u.user.name, u.user.email];
      const userProfileData = u.user.user_profile_data;
      let createdAt = '';
      let updatedAt = '';
      userRow.push(userProfileData && userProfileData.isProfileAllowed !== undefined ? userProfileData.isProfileAllowed : '');
      if (userProfileData) {
        profileQuestions.map((q) => {
          const answer = userProfileData.answered_questions.find(que => que.question_id === q.question_id);
          userRow.push(answer.value ? answer.value : '');
        });
        createdAt = this.getJsDate(userProfileData.created_timestamp);
        updatedAt = this.getJsDate(userProfileData.updated_timestamp);
      }
      // console.log({ u });

      userRow.push(createdAt);
      userRow.push(updatedAt);
      rows.push(userRow);
    });
    console.log({rows})
    const fileName = new Date().toDateString().split(' ').join('_');
    exportToCsv(`users_details_${fileName}.csv`, rows);
  }
  renderFilterForm = () => {
    return (
      <div className="filterWrapper">
        <Card title="Select filter date">
          <DatePicker
            value={this.state.selectedDate}
            onChange={this.handleDateChange}
            style={{
              width: 200
            }}
          />
          <Button
            type="primary"
            onClick={this.exportDailyAssessmentDataInCSV}
            style={{
              marginLeft: 16
            }}
          >Export In CSV</Button>
        </Card>
      </div>
    );
  }

  getAllUsers = async () => {
    if (!this.props.dashboardReducer.users) {
      try {
        this.setLoading(true);
        const getAllUsers = getApiCallable("getAllUsers");
        const users = await getAllUsers();
        this.setLoading(false);
        this.props.getAllUsersSuccess(users.data);
      } catch (error) {
        showNotif(error);
        this.setLoading(false);
      }
    }
  }

  switchPage = (page) => {
    this.setState({
      page
    });
    if (page === 'users') {
      this.getAllUsers();
    }
  }
  toggleView = (user) => {
    if (user.user.user_profile_data) {
      this.setState({
        viewStates: {
          ...this.state.viewStates,
          [user.user.user_id]: !this.state.viewStates[user.user.user_id]
        }
      });
    }
  }
  render() {
    const profileQuestions = this.props.dashboardReducer.profileQuestions;
    return (
      <div className="dashboardRoot">
        {
          this.state.boolLoading &&
          <div className="overlay">
            <Spin />
          </div>
        }
        <div className="header">
          <div className="left">
            <img
              src="https://res.cloudinary.com/urbanclap/image/upload/fl_progressive:steep/v1488970821/categories/category_v2/category_30813ea0.png"
              alt="UC Logo"
              className="logo"
            />
          </div>
          <div className="right">
            <p onClick={() => {this.switchPage('daily_assessment')}} className={cx(this.state.page === 'daily_assessment' ? 'active' : '', 'link')}>Daily Assessment Report</p>
            <p onClick={() => {this.switchPage('users')}} className={cx(this.state.page === 'users' ? 'active' : '', 'link')}>Users</p>
          </div>
        </div>
        <div className="content">
          {
            this.state.page === 'users' &&
            <div className="users">
              <h1>Users<span onClick={this.exportUsersData} className="exportUsers">Export</span></h1>
              {
                this.props.dashboardReducer.users &&
                this.props.dashboardReducer.users.map((user, index) => {
                  let style = {};
                  if (user.user.user_profile_data) {
                    user.user.user_profile_data.answered_questions.map((q, i) => {
                      const question = profileQuestions.find((ques) => ques.question_id === q.question_id);
                      q.text = question.text;
                    });
                  }
                  if (user.user.user_profile_data) {
                    style.cursor = 'pointer';
                    if (this.state.viewStates[user.user.user_id]) {
                      style.position = 'sticky';
                      style.top = 0;
                    }
                  }
                  return (
                    <div
                      className="userInfoRow"
                      key={index}
                    >
                      <div
                        onClick={() => {this.toggleView(user)}}
                        style={style}
                        className="basicDetails"
                      >
                        <span>{user.user.name}({user.user.email})</span>
                        {
                          user.user.user_profile_data &&
                          <Button
                            type="primary"
                            icon={this.state.viewStates[user.user.user_id] ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                            style={{
                              backgroundColor: '#6f6f6f',
                              border: 0,
                              borderRadius: 0
                            }}
                          >
                            { this.state.viewStates[user.user.user_id] ? 'Collapse' : 'Expand' }
                          </Button>
                        }
                      </div>
                      {
                        user.user.user_profile_data && this.state.viewStates[user.user.user_id] &&
                        <div className="profileDetails">
                          {
                            user.user.user_profile_data.answered_questions.map((q, i) => (
                            <div className="qa" key={i}>
                                <p className="q">{q.text}</p>
                                <p className="a">{q.value}</p>
                                {
                                  q.onSelectErrorMessage &&
                                  <p className="err">{q.onSelectErrorMessage}</p>
                                }
                              </div>
                            ))
                          }
                        </div>
                      }
                    </div>
                  )
                })
              }
            </div>
          }
          {
            this.state.page === 'daily_assessment' &&
            <div className="daily_assessment">
              {this.renderFilterForm()}
              {this.renderDataTable()}
            </div>
          }
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    dashboardReducer: state.dashboardReducer
  }),
  (dispatch) => bindActionCreators({ getSubmittedFormDataSuccess, getSubmittedFormDataFail, getAllUsersSuccess }, dispatch)
)(AdminDashboard);
